import { render, staticRenderFns } from "./comboboxMedicosComponent.vue?vue&type=template&id=db92c24c&scoped=true"
import script from "./comboboxMedicosComponent.vue?vue&type=script&lang=js"
export * from "./comboboxMedicosComponent.vue?vue&type=script&lang=js"
import style0 from "./comboboxMedicosComponent.vue?vue&type=style&index=0&id=db92c24c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db92c24c",
  null
  
)

export default component.exports